import { apiCall } from "../../services/api-service.js";

const get = (endpoint, params) => apiCall("get", endpoint, null, { params });
const post = (endpoint, body) => apiCall("post", endpoint, body);
const put = (endpoint, body) => apiCall("put", endpoint, body);
const del = (endpoint) => apiCall("delete", endpoint);

// Fetch all bank transactions
export const getBankTransactionListApi = async (params) => {
    try {
        return await get("bank_transaction", params);
    } catch (err) {
        console.error("Error fetching bank transactions:", err);
        return { data: { success: false, message: err.message } };
    }
};

// Create a new bank transaction
export const submitBankTransactionApi = async (body) => {
    try {
        return await post("bank_transaction", body);
    } catch (err) {
        console.error("Error creating bank transaction:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Fetch a single transaction for editing/drawer details
export const getBankTransactionByIdApi = async (id) => {
    try {
        return await get(`bank_transaction/edit/${id}`);
    } catch (err) {
        console.error("Error fetching bank transaction details:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Update an existing bank transaction
export const updateBankTransactionApi = async (id, body) => {
    try {
        return await put(`bank_transaction/${id}`, body);
    } catch (err) {
        console.error("Error updating bank transaction:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Delete a bank transaction
export const deleteBankTransactionApi = async (id) => {
    try {
        return await del(`bank_transaction/delete/${id}`);
    } catch (err) {
        console.error("Error deleting bank transaction:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Fetch transaction edit history
export const getBankTransactionHistoryApi = async (id) => {
    try {
        return await get(`bank_transaction/history/${id}`);
    } catch (err) {
        console.error("Error fetching transaction history:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Add remarks to a transaction
export const addBankTransactionRemarksApi = async (id, remarks) => {
    try {
        return await put(`bank_transaction/remarks/${id}`, { remarks });
    } catch (err) {
        console.error("Error adding remarks:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Download bulk upload Excel template
export const getBankTransactionTemplateDownloadApi = async () => {
    try {
        return await get("bank_transaction/template_download");
    } catch (err) {
        console.error("Error downloading template:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};

// Bulk upload Excel template
export const uploadBankTransactionExcelApi = async (base64String) => {
    try {
        const data = {
            upload_file: base64String,
        };
        return await post("bank_transaction/upload", data);
    } catch (err) {
        console.error("Error uploading excel:", err);
        if (err.response && err.response.data) {
            return err.response;
        } else {
            return { data: { success: false, message: err.message } };
        }
    }
};
